import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import CircularProgress from '@mui/material/CircularProgress'
import Checkbox from '@mui/material/Checkbox'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography';

import Form, { FORM_KIND_SUBSCRIPTIONS } from './Form';

import { loadSubscriptions, setSubscription, saveSubscriptions } from 'cityads-v3/actions/welcomeform';

import classes from './FormSubscriptions.scss';

export function FormSubscriptions({ title }) {
  const dispatch = useDispatch();

  const userId = useSelector(state => state.auth.user?.id);
  const language = useSelector(state => state.language.language);

  const userSubscriptionIds = useSelector(state => state.welcomeform.userSubscriptionIds);
  const userSubscriptionsById = useSelector(state => state.welcomeform.userSubscriptionsById);
  const isLoadedUserSubscriptions = useSelector(state => state.welcomeform.isLoadedUserSubscriptions);
  const isSaving = useSelector(state => state.welcomeform.isSavingSubscriptions);

  useEffect(() => {
    if (!userId) { return; }

    dispatch(loadSubscriptions());
  }, [dispatch, userId, language]);

  const [currentTab, setCurrentTab] = useState(null);
  const onTabChange = useCallback((evt, value) => {
    setCurrentTab(value);
  }, [setCurrentTab]);

  const currentTabWithDefault = currentTab ?? userSubscriptionIds[0];

  const onSubscriptionChange = useCallback((evt, value) => {
    dispatch(setSubscription(evt.target.name, value));
  }, [dispatch]);

  const onSave = useCallback(() => {
    if (!userId) { return; }

    return dispatch(saveSubscriptions());
  }, [dispatch, userId]);

  const onReset = useCallback(() => {
    if (!userId) { return; }

    dispatch(loadSubscriptions());
  }, [dispatch, userId]);

  if (!isLoadedUserSubscriptions) {
    return (
      <Form
        title       = {title}
        formKind    = {FORM_KIND_SUBSCRIPTIONS}
        showButtons = {false}
      >
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      </Form>
    );
  }

  return (
    <Form
      title    = {title}
      formKind = {FORM_KIND_SUBSCRIPTIONS}
      onSave   = {onSave}
      onReset  = {onReset}
      isPatchingForm = {isSaving}
    >
      <>
        <Tabs
          value    = {currentTabWithDefault}
          onChange = {onTabChange}
          indicatorColor = "primary"
          textColor      = "primary"
        >
          {userSubscriptionIds.map(id => (
            <Tab
              key   = {id}
              value = {id}
              label = {userSubscriptionsById[id].name}
            />
          ))}
        </Tabs>

        <div className={classes.content}>
          {userSubscriptionsById[currentTabWithDefault].childrenIds.map(id => (
            <label key={id} className={classes.item}>
              <span className={classes.itemSwitch}>
                <Checkbox
                  name={String(id)}
                  checked  = {userSubscriptionsById[id].is_active}
                  onChange = {onSubscriptionChange}
                />
              </span>
              <Typography className={classes.itemName}>
                {userSubscriptionsById[id].name}
              </Typography>
            </label>
          ))}
        </div>
      </>
    </Form>
  );
}

FormSubscriptions.propTypes = {
  title: PropTypes.string,
};

export default withTranslation(['Welcome'], { i18n, wait: false })(FormSubscriptions);
